import React from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import TimeInput from "../Component/TimeInput";
import RoundAndRepsInput from "../Component/RoundAndRepsInput";
import VideoURLInput from "../Component/VideoURLInput";
import PlaylistVideoBox from "../../../Share/PlaylistVideoBox";

export default function SubmitBox(props) {
  const {
    isSubmit,
    wodSubTitle,

    onChangeIsSuccess,
    onChangeMin,
    onChangeSec,
    onChangeMilliSec,
    onChangeRound,
    onChangeReps,
    onChangeCustomValue,

    onChangeTieBreakIsSuccess,
    onChangeTieBreakMin,
    onChangeTieBreakSec,
    onChangeTieBreakMilliSec,
    onChangeTieBreakRound,
    onChangeTieBreakReps,
    onChangeTieBreakCustomValue,

    scoreRules,
    scoreSheets,

    video,
    setVideo,

    onClickViewRuleBook
  } = props;

  const { t } = useTranslation();

  // 기록 컬럼 텍스트 정리 //
  function decideScoreRuleTitle(data) {
    if (scoreRules.length > 1) return wodSubTitle + '-' + String.fromCharCode(64 + data.viewIndex);
    else return wodSubTitle;
  }

  return (
    <TopLevelWrapper>
      <TopLineWrapper>
        <TopLineTextWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#4F4F4F'>{t('동작 기록하기')}</Text>
          <Text onClick={onClickViewRuleBook} fontFamily='NotoSansKR-Medium' fontSize={14} color='#FF8B48'>{t('룰북 다시보기')}</Text>
        </TopLineTextWrapper>
      </TopLineWrapper>
      {
        scoreRules.map((data, index) => (
          <ScoreRulesWrapper key={'ScoreRule-' + index}>
            <ColumnBoxWrapper>
              <ColumnBox>
                <Text fontFamily='Poppins-Bold' fontSize={14} color='#FFFFFF'>{decideScoreRuleTitle(data)}</Text>
              </ColumnBox>
            </ColumnBoxWrapper>
            {
              data.tag === 'ForTime' &&
              <ComponentWrapper>
                {
                  data.isUseTimeCap &&
                  <SuccessButtonWrapper>
                    <SuccessButton
                      isClicked={scoreSheets[index].isSuccess}
                      onClick={() => onChangeIsSuccess(true, index)}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 안에 성공')}</Text>
                    </SuccessButton>
                    <FailedButton
                      isClicked={!scoreSheets[index].isSuccess}
                      onClick={() => onChangeIsSuccess(false, index)}>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 터치')}</Text>
                    </FailedButton>
                  </SuccessButtonWrapper>
                }
                {
                  data.isUseTimeCap &&
                  <TotalInputWrapper style={{ marginTop: '8px' }}>
                    {
                      scoreSheets[index].isSuccess ?
                        <TotalInputWrapper>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('기록된 시간을 알려주세요')}</Text>
                          <TotalTimeInputWrapper>
                            <TimeInputWrapper>
                              <TimeInput
                                index={index}
                                value={scoreSheets[index].min}
                                setValue={onChangeMin}
                                unit='MIN'
                                isEdit={isSubmit} />
                            </TimeInputWrapper>
                            <TimeInputWrapper>
                              <TimeInput
                                index={index}
                                value={scoreSheets[index].sec}
                                setValue={onChangeSec}
                                unit='SEC'
                                isEdit={isSubmit} />
                            </TimeInputWrapper>
                            <TimeInputWrapper>
                              <TimeInput
                                index={index}
                                value={scoreSheets[index].milliSec}
                                setValue={onChangeMilliSec}
                                unit='MS'
                                isEdit={isSubmit} />
                            </TimeInputWrapper>
                          </TotalTimeInputWrapper>
                        </TotalInputWrapper>
                        :
                        <TotalInputWrapper>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                          <TotalTimeInputWrapper>
                            <RoundRepsInputWrapper>
                              <RoundAndRepsInput
                                index={index}
                                value={scoreSheets[index].round}
                                setValue={onChangeRound}
                                unit='R'
                                isEdit={isSubmit} />
                            </RoundRepsInputWrapper>
                            <RoundRepsInputWrapper>
                              <RoundAndRepsInput
                                index={index}
                                value={scoreSheets[index].reps}
                                setValue={onChangeReps}
                                unit='REPS'
                                isEdit={isSubmit} />
                            </RoundRepsInputWrapper>
                          </TotalTimeInputWrapper>
                        </TotalInputWrapper>
                    }
                  </TotalInputWrapper>
                }
                {
                  !data.isUseTimeCap &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('기록된 시간을 알려주세요')}</Text>
                    <TotalTimeInputWrapper>
                      <TimeInputWrapper>
                        <TimeInput
                          index={index}
                          value={scoreSheets[index].min}
                          setValue={onChangeMin}
                          unit='MIN'
                          isEdit={isSubmit} />
                      </TimeInputWrapper>
                      <TimeInputWrapper>
                        <TimeInput
                          index={index}
                          value={scoreSheets[index].sec}
                          setValue={onChangeSec}
                          unit='SEC'
                          isEdit={isSubmit} />
                      </TimeInputWrapper>
                      <TimeInputWrapper>
                        <TimeInput
                          index={index}
                          value={scoreSheets[index].milliSec}
                          setValue={onChangeMilliSec}
                          unit='MS'
                          isEdit={isSubmit} />
                      </TimeInputWrapper>
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
              </ComponentWrapper>
            }
            {
              data.tag === 'AMRAP' &&
              <ComponentWrapper>
                <TotalInputWrapper>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                  <TotalTimeInputWrapper>
                    <RoundRepsInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].round}
                        setValue={onChangeRound}
                        unit='R'
                        isEdit={isSubmit} />
                    </RoundRepsInputWrapper>
                    <RoundRepsInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].reps}
                        setValue={onChangeReps}
                        unit='REPS'
                        isEdit={isSubmit} />
                    </RoundRepsInputWrapper>
                  </TotalTimeInputWrapper>
                </TotalInputWrapper>
              </ComponentWrapper>
            }
            {/* {
              (data.tag === 'EMOM' || data.tag === 'TABATA') &&
              <ComponentWrapper>
                <TotalRoundCountInputWrapper>
                  {
                    scoreSheets[index].roundOfCount.map((roundData, roundIndex) => (
                      <RoundCountInputWrapper key={'ScoreSheet-' + roundIndex}>

                      </RoundCountInputWrapper>
                    ))
                  }
                </TotalRoundCountInputWrapper>
              </ComponentWrapper>
            } */}
            {
              data.tag === 'Custom' &&
              <ComponentWrapper>
                {
                  data.scoreKeyword === 'Not Scored' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <SuccessButtonWrapper>
                      <SuccessButton
                        isClicked={scoreSheets[index].isSuccess}
                        onClick={() => onChangeIsSuccess(true, index)}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('완료')}</Text>
                      </SuccessButton>
                      <FailedButton
                        isClicked={!scoreSheets[index].isSuccess}
                        onClick={() => onChangeIsSuccess(false, index)}>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('미완료')}</Text>
                      </FailedButton>
                    </SuccessButtonWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Time' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <TimeInputWrapper>
                        <TimeInput
                          index={index}
                          value={scoreSheets[index].min}
                          setValue={onChangeMin}
                          unit='MIN'
                          isEdit={isSubmit} />
                      </TimeInputWrapper>
                      <TimeInputWrapper>
                        <TimeInput
                          index={index}
                          value={scoreSheets[index].sec}
                          setValue={onChangeSec}
                          unit='SEC'
                          isEdit={isSubmit} />
                      </TimeInputWrapper>
                      <TimeInputWrapper>
                        <TimeInput
                          index={index}
                          value={scoreSheets[index].milliSec}
                          setValue={onChangeMilliSec}
                          unit='MS'
                          isEdit={isSubmit} />
                      </TimeInputWrapper>
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Reps' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].reps}
                        setValue={onChangeReps}
                        unit='REPS'
                        isEdit={isSubmit} />
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Rounds + Reps' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <RoundRepsInputWrapper>
                        <RoundAndRepsInput
                          index={index}
                          value={scoreSheets[index].round}
                          setValue={onChangeRound}
                          unit='R'
                          isEdit={isSubmit} />
                      </RoundRepsInputWrapper>
                      <RoundRepsInputWrapper>
                        <RoundAndRepsInput
                          index={index}
                          value={scoreSheets[index].reps}
                          setValue={onChangeReps}
                          unit='REPS'
                          isEdit={isSubmit} />
                      </RoundRepsInputWrapper>
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Distance' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].customValue}
                        setValue={onChangeCustomValue}
                        unit='m'
                        isEdit={isSubmit} />
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Weight' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].customValue}
                        setValue={onChangeCustomValue}
                        unit='lbs'
                        isEdit={isSubmit} />
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Point' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].customValue}
                        setValue={onChangeCustomValue}
                        unit='Point'
                        isEdit={isSubmit} />
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Peek Watt' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].customValue}
                        setValue={onChangeCustomValue}
                        unit='Peek Watt'
                        isEdit={isSubmit} />
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
                {
                  data.scoreKeyword === 'Max Speed' &&
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.customText}</Text>
                    <TotalTimeInputWrapper>
                      <RoundAndRepsInput
                        index={index}
                        value={scoreSheets[index].customValue}
                        setValue={onChangeCustomValue}
                        unit='Max Speed'
                        isEdit={isSubmit} />
                    </TotalTimeInputWrapper>
                  </TotalInputWrapper>
                }
              </ComponentWrapper>
            }

            {/* 타이브레이크 */}

            {
              data.isUseTieBreak &&
              <TieBreakScoreRulesWrapper>
                <ComponentWrapper style={{ marginTop: '15px' }}>
                  <TotalInputWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>TieBreak</Text>
                  </TotalInputWrapper>
                </ComponentWrapper>
                {
                  data.tieBreakTag === 'ForTime' &&
                  <ComponentWrapper>
                    {
                      data.tieBreakIsUseTimeCap &&
                      <SuccessButtonWrapper>
                        <SuccessButton
                          isClicked={scoreSheets[index].tieBreakIsSuccess}
                          onClick={() => onChangeTieBreakIsSuccess(true, index)}>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 안에 성공')}</Text>
                        </SuccessButton>
                        <FailedButton
                          isClicked={!scoreSheets[index].tieBreakIsSuccess}
                          onClick={() => onChangeTieBreakIsSuccess(false, index)}>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('타임캡 터치')}</Text>
                        </FailedButton>
                      </SuccessButtonWrapper>
                    }
                    {
                      data.tieBreakIsUseTimeCap &&
                      <TotalInputWrapper style={{ marginTop: '8px' }}>
                        {
                          scoreSheets[index].tieBreakIsSuccess ?
                            <TotalInputWrapper>
                              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('기록된 시간을 알려주세요')}</Text>
                              <TotalTimeInputWrapper>
                                <TimeInputWrapper>
                                  <TimeInput
                                    index={index}
                                    value={scoreSheets[index].tieBreakMin}
                                    setValue={onChangeTieBreakMin}
                                    unit='MIN'
                                    isEdit={isSubmit} />
                                </TimeInputWrapper>
                                <TimeInputWrapper>
                                  <TimeInput
                                    index={index}
                                    value={scoreSheets[index].tieBreakSec}
                                    setValue={onChangeTieBreakSec}
                                    unit='SEC'
                                    isEdit={isSubmit} />
                                </TimeInputWrapper>
                                <TimeInputWrapper>
                                  <TimeInput
                                    index={index}
                                    value={scoreSheets[index].tieBreakMilliSec}
                                    setValue={onChangeTieBreakMilliSec}
                                    unit='MS'
                                    isEdit={isSubmit} />
                                </TimeInputWrapper>
                              </TotalTimeInputWrapper>
                            </TotalInputWrapper>
                            :
                            <TotalInputWrapper>
                              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                              <TotalTimeInputWrapper>
                                <RoundRepsInputWrapper>
                                  <RoundAndRepsInput
                                    index={index}
                                    value={scoreSheets[index].tieBreakRound}
                                    setValue={onChangeTieBreakRound}
                                    unit='R'
                                    isEdit={isSubmit} />
                                </RoundRepsInputWrapper>
                                <RoundRepsInputWrapper>
                                  <RoundAndRepsInput
                                    index={index}
                                    value={scoreSheets[index].tieBreakReps}
                                    setValue={onChangeTieBreakReps}
                                    unit='REPS'
                                    isEdit={isSubmit} />
                                </RoundRepsInputWrapper>
                              </TotalTimeInputWrapper>
                            </TotalInputWrapper>
                        }
                      </TotalInputWrapper>
                    }
                    {
                      !data.tieBreakIsUseTimeCap &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('기록된 시간을 알려주세요')}</Text>
                        <TotalTimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              index={index}
                              value={scoreSheets[index].tieBreakMin}
                              setValue={onChangeTieBreakMin}
                              unit='MIN'
                              isEdit={isSubmit} />
                          </TimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              index={index}
                              value={scoreSheets[index].tieBreakSec}
                              setValue={onChangeTieBreakSec}
                              unit='SEC'
                              isEdit={isSubmit} />
                          </TimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              index={index}
                              value={scoreSheets[index].tieBreakMilliSec}
                              setValue={onChangeTieBreakMilliSec}
                              unit='MS'
                              isEdit={isSubmit} />
                          </TimeInputWrapper>
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                  </ComponentWrapper>
                }
                {
                  data.tieBreakTag === 'AMRAP' &&
                  <ComponentWrapper>
                    <TotalInputWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('얼마나 많은 라운드, 랩 수를 했나요?')}</Text>
                      <TotalTimeInputWrapper>
                        <TimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakRound}
                            setValue={onChangeTieBreakRound}
                            unit='R'
                            isEdit={isSubmit} />
                        </TimeInputWrapper>
                        <TimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakReps}
                            setValue={onChangeTieBreakReps}
                            unit='REPS'
                            isEdit={isSubmit} />
                        </TimeInputWrapper>
                      </TotalTimeInputWrapper>
                    </TotalInputWrapper>
                  </ComponentWrapper>
                }
                {/* {
              (data.tag === 'EMOM' || data.tag === 'TABATA') &&
              <ComponentWrapper>
                <TotalRoundCountInputWrapper>
                  {
                    scoreSheets[index].roundOfCount.map((roundData, roundIndex) => (
                      <RoundCountInputWrapper key={'ScoreSheet-' + roundIndex}>

                      </RoundCountInputWrapper>
                    ))
                  }
                </TotalRoundCountInputWrapper>
              </ComponentWrapper>
            } */}
                {
                  data.tieBreakTag === 'Custom' &&
                  <ComponentWrapper>
                    {
                      data.tieBreakScoreKeyword === 'Not Scored' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <SuccessButtonWrapper>
                          <SuccessButton
                            isClicked={scoreSheets[index].tieBreakIsSuccess}
                            onClick={() => onChangeTieBreakIsSuccess(true, index)}>
                            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('완료')}</Text>
                          </SuccessButton>
                          <FailedButton
                            isClicked={!scoreSheets[index].tieBreakIsSuccess}
                            onClick={() => onChangeTieBreakIsSuccess(false, index)}>
                            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF'>{t('미완료')}</Text>
                          </FailedButton>
                        </SuccessButtonWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Time' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              index={index}
                              value={scoreSheets[index].tieBreakMin}
                              setValue={onChangeTieBreakMin}
                              unit='MIN'
                              isEdit={isSubmit} />
                          </TimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              index={index}
                              value={scoreSheets[index].tieBreakSec}
                              setValue={onChangeTieBreakSec}
                              unit='SEC'
                              isEdit={isSubmit} />
                          </TimeInputWrapper>
                          <TimeInputWrapper>
                            <TimeInput
                              index={index}
                              value={scoreSheets[index].tieBreakMilliSec}
                              setValue={onChangeTieBreakMilliSec}
                              unit='MS'
                              isEdit={isSubmit} />
                          </TimeInputWrapper>
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Reps' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakReps}
                            setValue={onChangeTieBreakReps}
                            unit='REPS'
                            isEdit={isSubmit} />
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Rounds + Reps' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <RoundRepsInputWrapper>
                            <RoundAndRepsInput
                              index={index}
                              value={scoreSheets[index].tieBreakRound}
                              setValue={onChangeTieBreakRound}
                              unit='R'
                              isEdit={isSubmit} />
                          </RoundRepsInputWrapper>
                          <RoundRepsInputWrapper>
                            <RoundAndRepsInput
                              index={index}
                              value={scoreSheets[index].tieBreakReps}
                              setValue={onChangeTieBreakReps}
                              unit='REPS'
                              isEdit={isSubmit} />
                          </RoundRepsInputWrapper>
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Distance' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakCustomValue}
                            setValue={onChangeTieBreakCustomValue}
                            unit='m'
                            isEdit={isSubmit} />
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Weight' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakCustomValue}
                            setValue={onChangeTieBreakCustomValue}
                            unit='lbs'
                            isEdit={isSubmit} />
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Point' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakCustomValue}
                            setValue={onChangeTieBreakCustomValue}
                            unit='Point'
                            isEdit={isSubmit} />
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Peek Watt' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakCustomValue}
                            setValue={onChangeTieBreakCustomValue}
                            unit='Peek Watt'
                            isEdit={isSubmit} />
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                    {
                      data.tieBreakScoreKeyword === 'Max Speed' &&
                      <TotalInputWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{data.tieBreakCustomText}</Text>
                        <TotalTimeInputWrapper>
                          <RoundAndRepsInput
                            index={index}
                            value={scoreSheets[index].tieBreakCustomValue}
                            setValue={onChangeTieBreakCustomValue}
                            unit='Max Speed'
                            isEdit={isSubmit} />
                        </TotalTimeInputWrapper>
                      </TotalInputWrapper>
                    }
                  </ComponentWrapper>
                }
              </TieBreakScoreRulesWrapper>
            }

            {/* 타이브레이크 */}

          </ScoreRulesWrapper>
        ))
      }
      <ComponentWrapper style={{ marginTop: '20px' }}>
        <TotalInputWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#828282'>{t('EVENT 기록 영상')}</Text>
          <TotalTimeInputWrapper>
            <VideoURLInput
              value={video}
              setValue={setVideo}
              placeholder={t('유튜브 영상 링크를 붙여넣어 주세요')}
              isEdit={isSubmit} />
          </TotalTimeInputWrapper>
          {
            (video !== undefined && video !== '') &&
            <PlaylistVideoBox
              videoUrl={video}
              marginTop='12px'
              width='100%'
              height='auto'
              borderRadius='12px'
              thumbnailColor='#D9D9D9'
              noticeColor='#828282'
              noticeText={t('재생목록이 비공개로 설정되어 있어 재생할 수 없습니다')} />
          }
        </TotalInputWrapper>
      </ComponentWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  background-color: #FFFFFF;
`;

const TopLineTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 90.33%;
  height: 30px;
`;

const ScoreRulesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;
  
  width: 100%;
`;

const TieBreakScoreRulesWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 100%;
`;

const ColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-bottom: 8px;

  width: 90.33%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  height: 32px;

  border-radius: 6px;
  background-color: #6DD49E;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 90.33%;
`;

const SuccessButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;
`;

const SuccessButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 48%;
  height: 32px;

  border-radius: 10px;
  background-color: ${props => props.isClicked ? '#6DD49E' : '#D9D9D9'};
  
  transition: all 0.3s ease-in-out;
`;

const FailedButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 48%;
  height: 32px;

  border-radius: 10px;
  background-color: ${props => props.isClicked ? '#FF3131' : '#D9D9D9'};
  
  transition: all 0.3s ease-in-out;
`;

const TotalInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const TotalTimeInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 8px;

  width: 100%;
`;

const RoundRepsInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 48%;
`;

const TimeInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // width: 48%;
  width: 32%;
`;

const TotalRoundCountInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const RoundCountInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 10%;
  height: 10px;

  background-color: red;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  text-overflow: ellipsis;

  :hover {
    cursor: default;
  }
`;
